// removed by extract-text-webpack-plugin
module.exports = {"footerEnd":"_1udt","text":"_3Jq6","copyright":"_2cLE","orgNumber":"_166A"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Footer/FooterEnd/styles.scss
// module id = 433
// module chunks = 0